<script setup lang="ts">
import ReportConsDaysChart from './ReportConsDaysChart.vue'
import ReportConsDaysTable from './ReportConsDaysTable.vue'
import { useCabinetReports } from '@/pages/object/CabinetReports'

const report = useCabinetReports()
</script>

<template>
  <ReportConsDaysChart v-if="report.contentType == 'chart'" />
  <ReportConsDaysTable v-else />
</template>
